import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "./performance-optimization.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Suppress geolocation-related errors in development mode
// These are non-critical errors that occur when location permission is denied
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error;
  console.error = (...args) => {
    if (args[0] && typeof args[0] === 'string' && args[0].includes('Geolocation error')) {
      return; // Suppress geolocation errors in console
    }
    originalError.apply(console, args);
  };
}

// Handle unhandled promise rejections for geolocation errors
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && event.reason.message.includes('Geolocation')) {
    event.preventDefault(); // Prevent the error from showing in React error overlay
    console.log('Location permission denied - using default behavior');
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register();
